import PropTypes from 'prop-types'
import React from 'react'
import { ThemeContext } from 'styled-components'

import HowToResults from 'components/_special/HowToResults'
import SectionWrapper from 'components/SectionWrapper'
import { ResizeContext } from 'contexts/Resize'
import { dnaResults } from 'routes'

/**
 * DHowResults
 *
 * @param {object} props - properties of component
 * @returns {node} DHowResults
 */
const DHowResults = props => {
  const { index, data, pathCdn, locale, isSquareHidden } = props
  const { colors } = React.useContext(ThemeContext)
  const viewport = React.useContext(ResizeContext)
  const link = dnaResults.link(locale)
  const asPath = dnaResults.as(locale)

  return (
    <SectionWrapper isOverflowHidden={true}>
      <HowToResults
        isSquareHidden={isSquareHidden}
        viewport={viewport}
        index={index}
        title={data.title}
        content={data.content}
        link={link}
        asPath={asPath}
        buttonText={data.button}
        pathCdn={pathCdn}
        data={data.list}
        squareColor={colors.orange}
        isLast
      />
    </SectionWrapper>
  )
}

DHowResults.propTypes = {
  data: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  locale: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
  isSquareHidden: PropTypes.bool,
}

DHowResults.defaultProps = {
  isSquareHidden: false,
}

export default DHowResults
